/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */


import interfaceService from './interfaceService';
import { getBuyerHeaders, getBuyersUrl } from 'shared/http';
import { advisorAdd ,content, membershipUpdate, membershipList , giftAdd, giftEntryVerify} from 'shared/settings/apiconfig';


class PMService {
    constructor() {
        this.service = interfaceService.getService();
    }

    postqa(data) {
        return this.service.post(getBuyersUrl(advisorAdd), JSON.stringify(data),  getBuyerHeaders());
    }

    updateAutoRenew(autorenewStatus) {
        return this.service.put(getBuyersUrl(membershipUpdate), JSON.stringify(autorenewStatus), getBuyerHeaders())
    }

    getMembershipDetail(membershipData){
        return this.service.post(getBuyersUrl(membershipList), JSON.stringify(membershipData), getBuyerHeaders());
    }

    giftAdd(userData) {
        return this.service.post(getBuyersUrl(giftAdd), JSON.stringify({ "data" : userData}), getBuyerHeaders())
    }

    getGiftEntryVerify(){
        return this.service.get(getBuyersUrl(giftEntryVerify), getBuyerHeaders());
    }

    getContent(screenName,contentName) {
        const data = {
                "filter": [
                    {
                        "field": "status",
                        "value": "Active",
                        "op": "=",
                        "join": "AND"
                    },
                    {
                        "field": "screenname",
                        "value":screenName,
                        "op": "=",
                        "join": "AND"
                    },
                    {
                        "field": "contenttype",
                        "value": "JSON",
                        "op": "=",
                        "join": "AND"
                    }
                ]
            }

        return this.service.post(getBuyersUrl(content), JSON.stringify(data),  getBuyerHeaders());
    }


}

export default new PMService();